import {Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {ContentDetailMessage, ContentMessageDetailType} from '../../model/typings/content.types';

@Component({
  selector: 'cpui-message-content-detail',
  templateUrl: './message-content-detail.component.html',
  styleUrls: ['./message-content-detail.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessageContentDetailComponent implements OnInit {
  contentDetailMessage: ContentDetailMessage;
  contentDetailMessageType = ContentMessageDetailType;

  @Input('activeMessage')
  set activeMessage(activeMessage: ContentDetailMessage) {
    this.contentDetailMessage = activeMessage;
  }

  @Output() messageCloseAction: EventEmitter<string> = new EventEmitter();

  constructor() {

  }

  ngOnInit() {

  }

  closeMessageContentDetail(): void {
    this.messageCloseAction.emit(null);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/message-content-detail/message-content-detail.component.ts